if (!customElements.get('reference-hero')) {
  customElements.define('reference-hero', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.frames = [...this.querySelectorAll('[data-hero-frame]')];
      this.index = Math.max(0, this.frames.findIndex(frame => frame.classList.contains('is-active')));
      if (this.frames.length < 2) return;
      this.controls = this.querySelector('[data-hero-controls]');
      this.controls.hidden = false;
      this.status = this.querySelector('[data-hero-status]');
      this.toggle = this.querySelector('[data-hero-toggle]');
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.dataset.autoplay !== 'true' || this.reducedMotion.matches;
      this.visible = true;
      const listen = (target, type, fn) => target.addEventListener(type, fn, { signal: this.controller.signal });
      listen(this.querySelector('[data-hero-prev]'), 'click', () => this.show(this.index - 1, true));
      listen(this.querySelector('[data-hero-next]'), 'click', () => this.show(this.index + 1, true));
      listen(this.toggle, 'click', () => { this.paused = !this.paused; this.updateToggle(); this.schedule(); });
      listen(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      listen(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      listen(this, 'focusin', () => { this.focused = true; this.schedule(); });
      listen(this, 'focusout', (event) => { this.focused = this.contains(event.relatedTarget); this.schedule(); });
      listen(document, 'visibilitychange', () => this.schedule());
      listen(this.reducedMotion, 'change', () => { if (this.reducedMotion.matches) this.paused = true; this.updateToggle(); this.schedule(); });
      listen(this, 'shopify:block:select', (event) => {
        const index = this.frames.findIndex(frame => frame.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.updateToggle(); this.show(index, true); }
      });
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); });
      this.observer.observe(this);
      this.updateToggle();
      this.schedule();
    }
    updateToggle() {
      this.toggle.hidden = this.reducedMotion.matches;
      this.toggle.setAttribute('aria-label', this.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
      this.toggle.querySelector('[data-pause-icon]').hidden = this.paused;
      this.toggle.querySelector('[data-play-icon]').hidden = !this.paused;
    }
    show(next, announce = false) {
      this.index = (next + this.frames.length) % this.frames.length;
      this.frames.forEach((frame, index) => {
        frame.classList.toggle('is-active', index === this.index);
        frame.setAttribute('aria-hidden', String(index !== this.index));
      });
      if (announce) this.status.textContent = `${this.dataset.slideLabel} ${this.index + 1} / ${this.frames.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || !this.visible || document.hidden || this.reducedMotion.matches) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3, Number(this.dataset.interval) || 6) * 1000);
    }
    disconnectedCallback() {
      clearTimeout(this.timer);
      this.observer?.disconnect();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
